import React from 'react';
import { useCurrentNewsletterSubscription, useCurrentNewsletter } from '../../../hooks';
import Footer from './Footer';
import Header from './Header';
import Middle from './Middle';

const HEADER = 'header';
const MIDDLE = 'middle';
const FOOTER = 'footer';

const Layout = ({ currentUser, newsletterId, feedType, gdpr, gdprColorScheme }) => {
  const { isSubscribed } = useCurrentNewsletterSubscription(newsletterId);
  const { newsletter } = useCurrentNewsletter(newsletterId);

  if (!newsletter) {
    return null;
  }
  const renderFeed = () => {
    switch (feedType) {
      case HEADER:
        return (
          <Header
            newsletter={newsletter}
            newsletterId={newsletterId}
            isSubscribed={isSubscribed}
            currentUser={currentUser}
            gdpr={gdpr}
            gdprColorScheme={gdprColorScheme}
          />
        );
      case MIDDLE:
        return (
          <Middle
            newsletter={newsletter}
            newsletterId={newsletterId}
            isSubscribed={isSubscribed}
            currentUser={currentUser}
            gdpr={gdpr}
            gdprColorScheme={gdprColorScheme}
          />
        );
      case FOOTER:
        return (
          <Footer
            newsletter={newsletter}
            newsletterId={newsletterId}
            isSubscribed={isSubscribed}
            currentUser={currentUser}
            gdpr={gdpr}
            gdprColorScheme={gdprColorScheme}
          />
        );
      default:
        console.error('Unknown Feed Type');
    }
  };
  return renderFeed();
};

export default Layout;
